module.exports = __webpack_public_path__ + "img/singin-ghibli.b76d632d.png";